export default __webpack_public_path__ + "static/media/Vinit_Todai_Resume_Northwestern.b5ae0fae.pdf";